export default __webpack_public_path__ + "static/media/matplotlib.08e87e63.svg";